import { render, staticRenderFns } from "./tab5-setting.vue?vue&type=template&id=be822a46&scoped=true&"
import script from "./tab5-setting.vue?vue&type=script&lang=js&"
export * from "./tab5-setting.vue?vue&type=script&lang=js&"
import style0 from "./tab5-setting.vue?vue&type=style&index=0&id=be822a46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be822a46",
  null
  
)

export default component.exports